export default __webpack_public_path__ + "dcaf902c60683892ab8f3eb2c9124ada.woff";